// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1-sBu","location":"Header_location__2YwsI"};